const variation = (patchedFlags, originalImplementation) => (key, ...args) =>
  (patchedFlags || {})[key] !== undefined
    ? patchedFlags[key]
    : originalImplementation(key, ...args);

export default variation;
